import { FieldInputType, ProsemirrorHelper } from '@getaccept/editor-lib-new';
import { defineComponent } from 'vue';
import ProsemirrorViewerFormInput from './ProsemirrorViewerFormInput.vue';
export default defineComponent({
    name: 'InputSetLabel',
    components: {
        ProsemirrorViewerFormInput,
    },
    props: {
        input: { type: Object, default: () => ({}) },
        mergeValues: { type: Object, default: () => ({}) },
        fields: { type: Array, default: () => [] },
        editable: { type: Boolean, default: false },
    },
    setup() {
        return {
            getSafeText: ProsemirrorHelper.getSafeText,
            FieldInputType,
        };
    },
});
